import CompareChaptersContainer from './CompareChaptersContainer';

export default CompareChaptersContainer;
